// extracted by mini-css-extract-plugin
module.exports = {"empty-box":"empty-box__3gp4L","box":"box__1YKKr","title":"title__1jdkc","body":"body__3nNxY","button-wrapper":"button-wrapper__3qx-p","button":"button__x9doo","note":"note__2TM4N"};